<div class="operations-dashboard__sidebar" *transloco="let t; prefix: 'sidebar'" [ngClass]="{'collapse-dashboard__menus': isRailCollapsed, 'animate-sidebar': isAnimating}">
  <div class="operations-dashboard__menus">
    <ul>
      <!-- <li class="operations-dashboard__submenu">
        <a href="#" data-bs-toggle="dropdown" aria-expanded="false" class="operations-dashboard__menu-icon-text"
          [ngbTooltip]="isRailCollapsed ? 'Frequently Used' : ''" placement="right" triggers="hover">
          <span class="operations-dashboard__menu-icon">
            <i class="ph-duotone ph-star"></i>
          </span>
          <div class="operations-dashboard__menu-text">
            Frequently Used
            <span class="operations-dashboard__submenu-icon"><i class="ph ph-caret-down"></i></span>
          </div>
        </a>
        <ul class="dropdown-menu">
          <li><a href="#" [routerLink]="['/driver-management/dashboard']">Ops Dashboard</a></li>
          <li><a href="#" [routerLink]="['/driver-management/driver-manager']">Driver Manager</a></li>
          <li><a href="#" [routerLink]="['/driver-management/overtime-management']">Overtime Management</a></li>
        </ul>
      </li> -->
      <li routerLinkActive="active">
        <a href="#" [routerLink]="['/driver-management/overview']" class="operations-dashboard__menu-icon-text"
          [ngbTooltip]="isRailCollapsed ? t('driver.overview') : ''" placement="right" triggers="hover">
          <span class="operations-dashboard__menu-icon">
            <i class="ph-duotone ph-house"></i>
          </span>
          <div class="operations-dashboard__menu-text">{{ t('driver.overview') }}</div>
        </a>
      </li>
      <li class="operations-dashboard__submenu" routerLinkActive="active">
        <a href="#" data-bs-toggle="dropdown" aria-expanded="false" class="operations-dashboard__menu-icon-text"
          [ngbTooltip]="isRailCollapsed ? t('driver.driverManagement') : ''" placement="right" triggers="hover">
          <span class="operations-dashboard__menu-icon">
            <i class="ph-duotone ph-users-three"></i>
          </span>
          <div class="operations-dashboard__menu-text">
            {{ t('driver.driverManagement') }}
            <span class="operations-dashboard__submenu-icon"><i class="ph ph-caret-down"></i></span>
          </div>
        </a>
        <ul class="dropdown-menu">
          <li><a routerLinkActive="active" [routerLink]="['/driver-management/driver-information']">{{ t('driver.driverInformation') }}</a></li>
          <li><a routerLinkActive="active" [routerLink]="['/driver-management/driver-vehicle-assignment']">{{ t('driver.vehicleAssignment') }}</a></li>
          <!-- <li><a href="#">Incidents/Accidents</a></li> -->
          <li><a routerLinkActive="active" [routerLink]="['/driver-management/driver-documents']">{{ t('driver.driverDocuments') }}</a></li>
        </ul>
      </li>
      <li class="operations-dashboard__submenu nav-item dropdown" routerLinkActive="active">
        <a href="#" data-bs-toggle="dropdown" aria-expanded="false" class="operations-dashboard__menu-icon-text"
          [ngbTooltip]="isRailCollapsed ? t('driver.driverOperations') : ''" placement="right" triggers="hover">
          <span class="operations-dashboard__menu-icon">
            <i class="ph-duotone ph-steering-wheel"></i>
          </span>
          <div class="operations-dashboard__menu-text">
            {{ t('driver.driverOperations') }}
            <span class="operations-dashboard__submenu-icon"><i class="ph ph-caret-down"></i></span>
          </div>
        </a>
        <ul class="dropdown-menu">
          <li><a routerLinkActive="active" [routerLink]="['/driver-management/dashboard']">{{ t('driver.opsDashboard') }}</a></li>
          <!-- <li><a href="#">Drivers Status</a></li>
          <li><a href="#">Driver Performance</a></li> -->
          <li><a routerLinkActive="active" [routerLink]="['/driver-management/driver-manager']">{{ t('driver.driverManager') }}</a></li>
        </ul>
      </li>
      <li class="operations-dashboard__submenu" routerLinkActive="active">
        <a href="#" data-bs-toggle="dropdown" aria-expanded="false" class="operations-dashboard__menu-icon-text"
          [ngbTooltip]="isRailCollapsed ? t('driver.driverFinances') : ''" placement="right" triggers="hover">
          <span class="operations-dashboard__menu-icon">
            <i class="ph-duotone ph-money"></i>
          </span>
          <div class="operations-dashboard__menu-text">
            {{ t('driver.driverFinances') }}
            <span class="operations-dashboard__submenu-icon"><i class="ph ph-caret-down"></i></span>
          </div>
        </a>
        <ul class="dropdown-menu">
          <!-- <li><a href="#">Driver Performance</a></li>
          <li><a href="#">Fine Management</a></li> -->
          <li><a routerLinkActive="active" [routerLink]="['/driver-management/overtime-management']">{{ t('driver.overtimeManagement') }}</a></li>
        </ul>
      </li>
      <li routerLinkActive="active">
        <a  href="#" [routerLink]="['/driver-management/executive-stats']" class="operations-dashboard__menu-icon-text">
          <span class="operations-dashboard__menu-icon">
            <i class="ph-duotone ph-chart-bar"></i>
          </span>
          <div class="operations-dashboard__menu-text">{{ t('driver.executiveStats') }}</div>
        </a>
      </li>
    </ul>
    <button class="btn-collapse" [class.d-none]="isCompact" (click)="onToggleSidebar()">
      <span class="left-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
          fill="none">
          <path opacity="0.2" d="M10.5 5.25V18.75L3.75 12L10.5 5.25Z" fill="#EE2737" />
          <path
            d="M20.2501 11.25H11.2501V5.24998C11.2502 5.10156 11.2063 4.95644 11.1239 4.83299C11.0415 4.70955 10.9243 4.61333 10.7872 4.55651C10.6501 4.4997 10.4992 4.48485 10.3536 4.51383C10.2081 4.54282 10.0744 4.61435 9.96948 4.71936L3.21948 11.4694C3.14974 11.539 3.09443 11.6217 3.05668 11.7128C3.01894 11.8038 2.99951 11.9014 2.99951 12C2.99951 12.0985 3.01894 12.1961 3.05668 12.2872C3.09443 12.3782 3.14974 12.461 3.21948 12.5306L9.96948 19.2806C10.0744 19.3856 10.2081 19.4571 10.3536 19.4861C10.4992 19.5151 10.6501 19.5003 10.7872 19.4434C10.9243 19.3866 11.0415 19.2904 11.1239 19.167C11.2063 19.0435 11.2502 18.8984 11.2501 18.75V12.75H20.2501C20.449 12.75 20.6398 12.671 20.7804 12.5303C20.9211 12.3897 21.0001 12.1989 21.0001 12C21.0001 11.8011 20.9211 11.6103 20.7804 11.4697C20.6398 11.329 20.449 11.25 20.2501 11.25ZM9.7501 16.9397L4.81041 12L9.7501 7.06029V16.9397Z"
            fill="#EE2737" />
        </svg></span>
      <span class="collapse-btnt-text">{{ t('collapse') }}</span>
      <span class="right-arrow">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path opacity="0.2" d="M20.25 12L13.5 18.75V5.25L20.25 12Z" fill="#EE2737" />
          <path
            d="M20.7806 11.4695L14.0306 4.71948C13.9257 4.61447 13.792 4.54294 13.6465 4.51396C13.5009 4.48497 13.35 4.49982 13.2129 4.55664C13.0758 4.61345 12.9586 4.70967 12.8762 4.83312C12.7938 4.95656 12.7499 5.10168 12.75 5.2501V11.2501H3.75C3.55109 11.2501 3.36032 11.3291 3.21967 11.4698C3.07902 11.6104 3 11.8012 3 12.0001C3 12.199 3.07902 12.3898 3.21967 12.5304C3.36032 12.6711 3.55109 12.7501 3.75 12.7501H12.75V18.7501C12.7499 18.8985 12.7938 19.0436 12.8762 19.1671C12.9586 19.2905 13.0758 19.3868 13.2129 19.4436C13.35 19.5004 13.5009 19.5152 13.6465 19.4863C13.792 19.4573 13.9257 19.3857 14.0306 19.2807L20.7806 12.5307C20.8504 12.4611 20.9057 12.3784 20.9434 12.2873C20.9812 12.1963 21.0006 12.0987 21.0006 12.0001C21.0006 11.9015 20.9812 11.8039 20.9434 11.7129C20.9057 11.6218 20.8504 11.5391 20.7806 11.4695ZM14.25 16.9398V7.06041L19.1897 12.0001L14.25 16.9398Z"
            fill="#EE2737" />
        </svg>
      </span>
    </button>
  </div>
</div>